import { gql } from '@apollo/client';

export const GET_DATA_EXPORT_MESSAGES = gql`
  query dataExportTrackingsConnection(
    $first: Int
    $after: Cursor
    $last: Int
    $before: Cursor
    $filter: DataExportTrackingFilter
    $condition: DataExportTrackingCondition
    $orderBy: [DataExportTrackingsOrderBy!]
  ) {
    dataExportTrackingsConnection(
      first: $first
      after: $after
      last: $last
      before: $before
      filter: $filter
      condition: $condition
      orderBy: $orderBy
    ) {
      edges {
        node {
          id
          dateTime
          user
          exportType
          recordType
          recordCount
          appliedFilters
          completionTime
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const ADD_DATA_EXPORT_MESSAGE = gql`
  mutation AddDataExportMessage(
    $id: String!,
    $dateTime: DateTime,
    $user: String,
    $exportType: String,
    $recordType: String,
    $recordCount: Int,
    $appliedFilters: JSON,
    $completionTime: Int
  ) {
    addDataExportMessage(
      id: $id,
      dateTime: $dateTime,
      user: $user,
      exportType: $exportType,
      recordType: $recordType,
      recordCount: $recordCount,
      appliedFilters: $appliedFilters,
      completionTime: $completionTime
    ) {
      id
      dateTime
      user
      exportType
      recordType
      recordCount
      appliedFilters
      completionTime
    }
  }
`;